var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"light":""}},[_c('Header'),_vm._v(" "),_c('Navigation'),_vm._v(" "),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('Messages'),_vm._v(" "),_c('nuxt')],1)],1),_vm._v(" "),_c('div',{staticClass:"mt-6"},[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }